export default __webpack_public_path__ + "static/media/Avatar-27-noback.d9d65345.png";